<template>
	<div>
		<div class="rule-icon" @click="popupVisible = true">规则</div>
		<van-popup v-model="popupVisible" position="bottom" round>
			<div class="popup-content">
				<div class="popup-tit">规则 <van-icon name="cross" @click="popupVisible = false"/></div>
				<div class="popup-text">
					<p>{{ desc }}</p>
				</div>
			</div>
		</van-popup>
	</div>
</template>
<script>
	export default {
		name: "RuleIcon",
		data() {
			return {
				popupVisible: false,
				desc: "1. 本活动仅限库迪咖啡小程序和APP大陆地区用户参与；\n2. 用户授权协议详见《用户授权协议》；\n3. 本活动最终解释权归库迪咖啡所有。",
			};
		},
		methods: {},
	};
</script>
<style lang="scss" scoped>
	.rule-icon {
		width: 70px;
		height: 70px;
    background: rgba(0, 0, 0, 0.15);
		border-radius: 50%;
		line-height: 70px;
		font-family: AlibabaPuHuiTiM;
		font-size: 23px;
		color: #ffffff;
		text-align: center;
	}
  .van-popup--bottom {
    border-radius: 16px 16px 0 0;

    .popup-content {
      width: 100%;
      height: 100%;

      .popup-tit {
        position: relative;
        text-align: center;
        line-height: 96px;
        height: 96px;
        color: #3A3B3C;
        font-size: 32px;
        font-weight: bold;
      }

      .van-icon-cross {
        position: absolute;
        right: 20px;
        top: 25px;
        font-size: 36px;
      }

      .popup-text {
        //width: calc(100% - 96px);
        padding: 0 32px;
        line-height: 40px;
        margin: auto;
        max-height: 900px;
        overflow: auto;

        p {
          margin-top: 16px;
          font-size: 26px;
          white-space: pre-wrap;
          color: #3A3B3C;
        }
      }

      .popup-btn {
        width: calc(100% - 64px);
        margin: 0 auto;
        margin-top: 16px;
        margin-bottom: 48px;
        line-height: 96px;
        background: linear-gradient( 153deg, #FF7673 0%, #FF3D3D 100%);
        border-radius: 8px;
        color: #FFFFFF;
        font-weight: bold;
        font-size: 32px;
        text-align: center;
        border-radius: 48px;
      }
    }
  }

</style>
